import axios from 'axios'
import VUE_APP_API_GAEA_URL from './getapi/gaea'

let apiURL = ''
// console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://proxy.jiankanghao.net:50205/api/v1'
  // apiURL = 'https://gaea.haiweikexin.com/api/v1/'
}else {
  // alert("生产环境");
  apiURL = VUE_APP_API_GAEA_URL
}

let http = axios.create({
  timeout: 12000,
  baseURL: apiURL,
  headers: {'Content-Type': 'application/json'}
});
http.interceptors.request.use(
  config => {
    let time = new Date().getTime();
    console.log(config);
// 转换为东八区时间
    const easternTime = time + (8 * 60 * 60);
// 转换为13位精确到毫秒时间戳
    const timestamp8 = easternTime.toString();
    switch (config.method) {
      case "get":
        //第一步对入参进行添加时间戳并根据key值排序
        config.params = {
          ...config.params,
          'timestamp': timestamp8,
        }
        const sortedObj1 = {};
        Object.keys(config.params)
          .sort()
          .forEach(key => {
            sortedObj1[key] = config.params[key];
          });
        config.params = sortedObj1
        //第二步对对象进行转为url入参形式的字符串
        const paramsString = Object.entries(config.params)
          .map(([key, value]) => `${key}=${value}`)
          .join('&');

        break;
      case "post":
        config.data = {
          ...config.data,
          'timestamp': timestamp8,
        }
        const sortedObj2 = {};
        Object.keys(config.data)
          .sort()
          .forEach(key => {
            sortedObj2[key] = config.data[key];
          });
        config.data = sortedObj2

        //第二步对对象进行转为url入参形式的字符串
        const paramsString1 = Object.entries(config.data)
          .map(([key, value]) => `${key}=${value}`)
          .join('&');
        /***
         *第三步取aes_key 跟 aes_iv的索引
         * aes_key的索引为时间戳前8位后8位
         *aes_iv的索引为时间戳后8位前8位
         * **/
        let front1 = timestamp8.substring(0, 8);
        let back1 = timestamp8.substring(timestamp8.length - 8);
        let key_val1 = front1 + back1;
        //将aes_key转为可以读取的下标
        key_val1 = Array.from(key_val1).join(",");
        //将aes_iv转为可以读取的下标
        let iv_val1 = back1 + front1;
        iv_val1 = Array.from(iv_val1).join(",");
        let keyArray1 = key_val1.split(",");
        //获取token并去除Bearer

        if(config.headers.Authorization) {
          let token1 = config.headers.Authorization.replace("Bearer ", '')
          //拿到aes_key
          let keyresult1 = "";
          for (let i = 0; i < keyArray1.length; i++) {
            let index = parseInt(keyArray1[i]);
            let char = token1[index];
            keyresult1 += char;
          }
          //拿到aes_iv
          let ivArray1 = iv_val1.split(",");
          let ivresult1 = "";
          for (let i = 0; i < ivArray1.length; i++) {
            let index = parseInt(ivArray1[i]);
            let char = token1[index];
            ivresult1 += char;
          }
          const key1 = CryptoJS.enc.Utf8.parse(keyresult1)
          const iv1 = CryptoJS.enc.Utf8.parse(ivresult1)
          // 加密
          let ciphertext1 = CryptoJS.AES.encrypt(paramsString1, key1, {
            iv: iv1,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          // console.log(ciphertext1.toString());
          config.headers['HW-SIGNATURE'] = ciphertext1.toString();
        }
        if(config.url == 'sms_code'){
          const keys = CryptoJS.enc.Utf8.parse('xfJgOEfkzjeavxWH')
          const ivs = CryptoJS.enc.Utf8.parse('PCeTASGYMRIRoyQz')
          let SIGNATURE = CryptoJS.AES.encrypt(paramsString1, keys, {
            iv: ivs,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          // console.log(ciphertext.toString());
          config.headers['HW-SIGNATURE'] = SIGNATURE.toString();
        }
        break;
      case "put":
        config.data = {
          ...config.data,
          'timestamp': timestamp8,
        }
        const sortedObj3 = {};
        Object.keys(config.data)
          .sort()
          .forEach(key => {
            sortedObj3[key] = config.data[key];
          });
        config.data = sortedObj3

        //第二步对对象进行转为url入参形式的字符串
        const paramsString2 = Object.entries(config.data)
          .map(([key, value]) => `${key}=${value}`)
          .join('&');
        /***
         *第三步取aes_key 跟 aes_iv的索引
         * aes_key的索引为时间戳前8位后8位
         *aes_iv的索引为时间戳后8位前8位
         * **/
        let front2 = timestamp8.substring(0, 8);
        let back2 = timestamp8.substring(timestamp8.length - 8);
        let key_val2 = front2 + back2;
        //将aes_key转为可以读取的下标
        key_val2 = Array.from(key_val2).join(",");
        //将aes_iv转为可以读取的下标
        let iv_val2 = back2 + front2;
        iv_val2 = Array.from(iv_val2).join(",");
        let keyArray2 = key_val2.split(",");
        //获取token并去除Bearer

        if(config.headers.Authorization) {
          let token2 = config.headers.Authorization.replace("Bearer ", '')
          //拿到aes_key
          let keyresult2 = "";
          for (let i = 0; i < keyArray2.length; i++) {
            let index = parseInt(keyArray2[i]);
            let char = token2[index];
            keyresult2 += char;
          }
          //拿到aes_iv
          let ivArray2 = iv_val2.split(",");
          let ivresult2 = "";
          for (let i = 0; i < ivArray2.length; i++) {
            let index = parseInt(ivArray2[i]);
            let char = token2[index];
            ivresult2 += char;
          }
          const key2 = CryptoJS.enc.Utf8.parse(keyresult2)
          const iv2 = CryptoJS.enc.Utf8.parse(ivresult2)
          // 加密
          let ciphertext2 = CryptoJS.AES.encrypt(paramsString2, key2, {
            iv: iv2,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          // console.log(ciphertext2.toString(),'dadadad');
          config.headers['HW-SIGNATURE'] = ciphertext2.toString();
        }
        if(config.url == 'sms_code'){
          let SIGNATURE = CryptoJS.AES.encrypt(paramsString, 'xfJgOEfkzjeavxWH', {
            iv: 'PCeTASGYMRIRoyQz',
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          // console.log(ciphertext.toString());
          config.headers['KX-SIGNATURE'] = SIGNATURE.toString();
        }
        break;
      case "delete":
        config.data = {
          ...config.data,
          'timestamp': timestamp8,
        }
        const sortedObj4 = {};
        Object.keys(config.data)
          .sort()
          .forEach(key => {
            sortedObj4[key] = config.data[key];
          });
        config.data = sortedObj4
        //第二步对对象进行转为url入参形式的字符串
        const paramsString3 = Object.entries(config.data)
          .map(([key, value]) => `${key}=${value}`)
          .join('&');
        /***
         *第三步取aes_key 跟 aes_iv的索引
         * aes_key的索引为时间戳前8位后8位
         *aes_iv的索引为时间戳后8位前8位
         * **/
        let front3 = timestamp8.substring(0, 8);
        let back3 = timestamp8.substring(timestamp8.length - 8);
        let key_val3= front3 + back3;
        //将aes_key转为可以读取的下标
        key_val3 = Array.from(key_val3).join(",");
        //将aes_iv转为可以读取的下标
        let iv_val3 = back3 + front3;
        iv_val3 = Array.from(iv_val3).join(",");
        let keyArray3 = key_val3.split(",");
        //获取token并去除Bearer

        if(config.headers.Authorization) {
          let token3 = config.headers.Authorization.replace("Bearer ", '')
          //拿到aes_key
          let keyresult3 = "";
          for (let i = 0; i < keyArray3.length; i++) {
            let index = parseInt(keyArray3[i]);
            let char = token3[index];
            keyresult3 += char;
          }
          //拿到aes_iv
          let ivArray3 = iv_val3.split(",");
          let ivresult3 = "";
          for (let i = 0; i < ivArray3.length; i++) {
            let index = parseInt(ivArray3[i]);
            let char = token3[index];
            ivresult3 += char;
          }
          const key3 = CryptoJS.enc.Utf8.parse(keyresult3)
          const iv3 = CryptoJS.enc.Utf8.parse(ivresult3)
          // 加密
          let ciphertext3 = CryptoJS.AES.encrypt(paramsString3, key3, {
            iv: iv3,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          config.headers['HW-SIGNATURE'] = ciphertext3.toString();
        }
        break;
    }
    return config
  },
  error => {
  });

export default http;



// WEBPACK FOOTER //
// ./src/util/gaeaApiConfig.js